import style from './CrossIcon.module.scss';

import { Icon, IconType } from '@components/Icon';

import { EscapeButton, EscapeButtonModifiers } from '../EscapeButton';

interface CrossIconProps {
    onClose(): void;
}

export function CrossIcon({ onClose }: CrossIconProps) {
    return (
        <div
            className={style.root}
            onClick={onClose}
        >
            <EscapeButton
                modifiers={[EscapeButtonModifiers.WithCrossIcon]}
                onClose={onClose}
            />
            <div className={style.iconWrapper}>
                <Icon type={IconType.CROSS} />
            </div>
        </div>
    );
}
